export default "__VITE_ASSET__DGCKFIVd__"